<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { useI18n } from 'vue-i18n'

// Aviso de nova versão sem recarregar durante formulário/ativação (§12.8).
const { t } = useI18n()
const { needRefresh, offlineReady, updateServiceWorker } = useRegisterSW()
const offline = ref(!navigator.onLine)

onMounted(() => {
  window.addEventListener('online', () => (offline.value = false))
  window.addEventListener('offline', () => (offline.value = true))
})
</script>

<template>
  <RouterView />

  <!-- Sem conexão: estrutura visível + aviso, sem dados fictícios (§12.8) -->
  <div
    v-if="offline"
    class="fixed inset-x-0 top-0 z-50 bg-warning-soft px-4 py-2 text-center text-sm font-medium text-warning safe-top"
    role="status"
  >
    {{ t('pwa.offline_banner') }}
  </div>

  <div
    v-if="needRefresh"
    class="fixed inset-x-4 bottom-24 z-50 flex items-center justify-between gap-3 rounded-2xl bg-ink px-4 py-3 text-sm text-white shadow-[var(--shadow-pop)]"
    role="alert"
  >
    <span>{{ t('pwa.update_available') }}</span>
    <button class="font-semibold text-accent" @click="updateServiceWorker()">{{ t('pwa.update_now') }}</button>
  </div>
</template>
